export const handlePlural = (unit, parsedQuantity, quantity) => {
  const isGermany = process.env.GATSBY_CURRENT_BUILD
  const localeUnit = unit
    ? unit.includes(':')
      ? unit.split(':')
      : [unit, unit]
    : null
  let localeUnits = []

  localeUnits = localeUnit ? (isGermany ? localeUnit[0] : localeUnit[1]) : unit
  const units = localeUnits.split('-')
  let parsedUnit = units[0]
  if (parsedQuantity == ' Prise') {
    parsedUnit = ''
  }
  if (quantity > 1 && Array.isArray(units) && units.length > 1) {
    parsedUnit = units[1]
  }

  return parsedUnit
}
